import { Component } from '@angular/core';
import { HrTranslateKey } from '../../translate/hr-translate-key';

@Component({
    selector: 'hr-accordion',
    templateUrl: './hr-accordion.component.html',
})
export class HrAccordionComponent {
    constructor() {}

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }
}
